import { gql } from "@apollo/client";
import { organizationAppsFragment } from "../fragments";

export const getOrganizationApps = gql`
    query GetOrganizationApps($organizationId: String = null) {
        getAppList(input: { orgId: $organizationId, cursor: "" }) {
            ...OrganizationApps
        }
    }
    ${organizationAppsFragment}
`;
